// Enums of the `courses` Postgres schema (ported from the Lovable/Supabase courses app).

import { UserRole } from './user-role.enum';

export enum CoursesAiModel {
	Chatgpt = 'chatgpt',
	Gemini = 'gemini',
	Claude = 'claude',
}

export enum CoursesAmaStatus {
	Pending = 'pending',
	Answered = 'answered',
	Archived = 'archived',
}

export enum CoursesAttemptStatus {
	Passed = 'passed',
	Failed = 'failed',
	Pending = 'pending',
}

export enum CoursesChallengeStatus {
	Active = 'active',
	Completed = 'completed',
}

export enum CoursesCourseStatus {
	Draft = 'draft',
	Published = 'published',
	Completed = 'completed',
}

export enum CoursesJournalStatus {
	Submitted = 'submitted',
	Reviewed = 'reviewed',
}

export enum CoursesLessonContentType {
	TextArticle = 'text_article',
	Video = 'video',
	Pdf = 'pdf',
	ExternalLink = 'external_link',
	Slides = 'slides',
	Epub = 'epub',
	Quiz = 'quiz',
	Journal = 'journal',
	Webview = 'webview',
}

export enum CoursesQuestionMode {
	OpenEnded = 'open_ended',
	FixedAnswer = 'fixed_answer',
	ShortAnswer = 'short_answer',
}

export enum CoursesWebinarStatus {
	Gauging = 'gauging',
	Scheduled = 'scheduled',
	/** Closed by an admin, or automatically once its scheduled start has passed. */
	Completed = 'completed',
	Cancelled = 'cancelled',
}

/** Audience roles of a courses email broadcast; `paid_user` is not a `UserRole`. */
export enum CoursesBroadcastAudienceRole {
	User = UserRole.User,
	PaidUser = 'paid_user',
	Mentor = UserRole.Mentor,
	Admin = UserRole.Admin,
}

/** Party of an office-hours booking that receives a notification email. */
export enum CoursesBookingParty {
	Student = 'student',
	Mentor = 'mentor',
}

export enum CourseSortKey {
	Recent = 'recent',
	Title = 'title',
	Progress = 'progress',
}
